import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import { PagedClientLookupDto } from '../../dtos/client-lookup.dto';

// Independent mirror of `features/clients`' `GET /api/clients/search` call -- `features/settings`
// is not allowed to import `features/clients`' repository/DTOs (see `tools/check-architecture.mjs`'s
// cross-feature import rule), so this is its own narrow datasource against the same endpoint.
@Injectable()
export class ClientLookupRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public search(term: string, page = 1, pageSize = 20): Observable<PagedClientLookupDto> {
    return this.http.get<PagedClientLookupDto>(`${this.apiUrl}${API_ENDPOINTS.clients.search}`, {
      params: { term, page, pageSize },
    });
  }
}
